import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, InputNumber, Button } from 'antd';
import { formatMoney, unFormat } from 'shared/utils/StringUtil';

class NewFilterRangeInput extends PureComponent {
  _onValidate = (err, formValues) => {
    const {
      onSubmitForm,
      options: { unit, formater },
    } = this.props;
    if (!err) {
      let customLabel = `${formValues.min}${unit} to ${formValues.max}${unit}`;
      if (formater) {
        customLabel = `${formater(formValues.min.toString())} to ${formater(
          formValues.max.toString(),
        )}`;
      }

      onSubmitForm([formValues.min, formValues.max], customLabel);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  _renderNumInput = () => {
    const {
      options: { range, step, useFormatter },
    } = this.props;

    const formater = useFormatter
      ? { formatter: formatMoney, parser: unFormat }
      : {};

    const defaultInputProps = {
      min: range[0],
      max: range[1],
      step,
      style: { width: '100%' },
      ...formater,
    };
    return <InputNumber size="large" {...defaultInputProps} />;
  };

  customValidation = validText => (rule, value, callback) => {
    const {
      form: { getFieldValue },
      options: { range, float },
    } = this.props;

    let amount = parseInt(value, 10);
    let amountMin = parseInt(getFieldValue('min'), 10);
    if (float) {
      amount = parseFloat(value, 10);
      amountMin = parseFloat(getFieldValue('min'), 10);
    }
    if (value) {
      if (validText.includes('Max') && amount <= amountMin) {
        callback('Maximum Amount tidak bisa lebih rendah dari Minimal Amount');
      } else if (amount < range[0] || amount > range[1]) {
        callback(`${validText}: ${range[0]} - ${range[1]} IDR`);
      } else {
        callback();
      }
    } else {
      callback(`${validText} tidak boleh kosong`);
    }
  };

  render = () => {
    const { onCancelForm, options } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Item label={options.minLabel} required={false} colon={false}>
          {getFieldDecorator('min', {
            rules: [
              {
                validator: this.customValidation('Min'),
              },
            ],
          })(this._renderNumInput())}
        </Form.Item>
        <Form.Item label={options.maxLabel} required={false} colon={false}>
          {getFieldDecorator('max', {
            rules: [
              {
                validator: this.customValidation('Max'),
              },
            ],
          })(this._renderNumInput())}
        </Form.Item>
        <Button className="btn cancel-btn" onClick={onCancelForm}>
          Cancel
        </Button>
        <Button type="primary" htmlType="submit" className="btn">
          Submit
        </Button>
      </Form>
    );
  };
}

NewFilterRangeInput.propTypes = {
  form: PropTypes.object,
  onCancelForm: PropTypes.func,
  onSubmitForm: PropTypes.func,
  options: PropTypes.object,
};

export default NewFilterRangeInput;
